module.exports = __webpack_public_path__ + "assets/teethRightside.3e007d5997250ef491342948ba11ba32.png";